import * as types from '../actions/actionTypes';
import initialState from './initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_ALERT: {
      const { payload, meta } = action;
      const alert = {
        ...payload,
        // fingerprint let's devs/the system control how to use the alert (how to display/remove it)
        fingerprint: meta.fingerprint
      };

      return {
        ...state,
        [meta.fingerprint]: alert
      };
    }
    case types.DELETE_ALERT: {
      const { meta } = action;
      const { fingerprint: deletedAlert } = meta;

      const { [deletedAlert]: _, ...nextAlerts } = state;
      return nextAlerts;
    }
    default:
      return state;
  }
};

export default reducer;
